import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {TechnicalDeviceDocumentTypesService} from '@providers/dechnical-device-document-types/technical-device-document-types.service';
import {SelectValueInterface} from '@interfaces/select-value.interface';

@Injectable()
export class TechnicalDeviceDocumentTypesProvider extends BaseProvider<SelectValueInterface[]> {
    public defaultValue = [];

    constructor(
        service: TechnicalDeviceDocumentTypesService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }
}
